module.exports = __webpack_public_path__ + "fonts/benchnine-v9-latin-regular.c43297ec.ttf";